import { parse } from 'query-string';

import { getUrl, Request } from '../../request';

export const getProductSliders = (city_id, category_id, home_page = false) => {
  const query = {
    city_id,
    category_id
  };
  if (home_page) {
    query.home_page = 1;
  }
  return Request.get(getUrl('/api/v1/sellers/product-sliders/'), query);
};

export const getProducts = (city_id, category_id, filter_query) => {
  const query = {
    ...parse(filter_query),
    city_id,
    category_id
  };
  return Request.get(getUrl('/api/v1/sellers/products/'), query);
};

export const getSearch = (city_id, search) => {
  const query = {
    city_id,
    search
  };
  return Request.get(getUrl('/api/v1/sellers/products-search/'), query);
};

export const postCard = (seller_product_id, city_id, quantity, cart_items) => {
  const body = {
    seller_product_id,
    city_id,
    quantity,
    cart_items
  };
  return Request.post(getUrl('/api/v1/sellers/card/'), body);
};

export const getProductFilters = (category_id, city_id) => {
  const query = {
    category_id,
    city_id
  };
  return Request.get(getUrl('/api/v1/sellers/products-filters/'), query);
};

export const postProductDeliveries = (seller_product_ids, city_id) =>
  Request.post(getUrl('/api/v1/sellers/product-delivery/'), {
    seller_product_ids,
    city_id
  });

export const getProductDeliveries = (seller_product_id, city_id) =>
  Request.post(getUrl('/api/v1/sellers/product-delivery/'), {
    seller_product_id,
    city_id
  });
